import React from "react";
import { T } from "../../app/tokens.js";

/**
 * Persistent, non-interactive explanation of an Admin section and its readers.
 * @param {{ purpose: string, label: "Used by" | "Source", values: string[] }} props
 */
export function AdminSectionExplainer({ purpose, label, values }) {
  return (
    <section
      data-testid="admin-section-explainer"
      style={{
        background: T.adminExplainerBg,
        color: T.adminExplainerFg,
        border: `1px solid ${T.adminExplainerBorder}`,
        borderRadius: 11,
        padding: "14px 17px",
        margin: "10px 0 20px",
      }}
    >
      <div style={{
        color: T.adminExplainerLabel,
        fontSize: T.fsXxs,
        fontWeight: T.fwBold,
        letterSpacing: ".05em",
        textTransform: "uppercase",
        marginBottom: 4,
      }}>
        What this section does
      </div>
      <div style={{
        color: T.adminExplainerFg,
        fontSize: T.fsMd,
        lineHeight: 1.55,
      }}>
        {purpose}
      </div>
      <div style={{
        display: "flex",
        alignItems: "center",
        gap: 7,
        flexWrap: "wrap",
        marginTop: 10,
        paddingTop: 9,
        borderTop: `1px solid ${T.adminExplainerBorder}`,
      }}>
        <span style={{
          color: T.adminExplainerLabel,
          fontSize: T.fsXxs,
          fontWeight: T.fwBold,
          letterSpacing: ".04em",
          textTransform: "uppercase",
        }}>
          {label}
        </span>
        {values.map((value) => (
          <span
            key={value}
            style={{
              color: T.adminExplainerFg,
              background: T.white,
              border: `1px solid ${T.adminExplainerBorder}`,
              borderRadius: 14,
              padding: "2px 10px",
              fontSize: T.fsXs,
              fontWeight: T.fwBold,
            }}
          >
            {value}
          </span>
        ))}
      </div>
    </section>
  );
}

export default AdminSectionExplainer;